import type { Card, Rank, Suit } from './types';
import { mulberry32, shuffleInPlace } from './rng';

const RANKS: Rank[] = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
const SUITS: Suit[] = ['hearts', 'diamonds', 'clubs', 'spades'];

const rankValue: Record<Rank, number> = {
  '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, '10': 10,
  'J': 11, 'Q': 12, 'K': 13, 'A': 14, 'JOKER': 0,
};

/**
 * Build a single 54-card deck (52 + 2 Jokers).
 */
export function buildSingleDeck(prefix: string): Card[] {
  const cards: Card[] = [];
  for (const suit of SUITS) {
    for (const rank of RANKS) {
      cards.push({
        id: `${prefix}-${suit}-${rank}`,
        suit,
        rank,
        value: rankValue[rank],
      });
    }
  }
  cards.push({ id: `${prefix}-joker-1`, suit: 'joker', rank: 'JOKER', value: 0 });
  cards.push({ id: `${prefix}-joker-2`, suit: 'joker', rank: 'JOKER', value: 0 });
  return cards;
}

/**
 * Combine TWO decks (108 cards total, including 4 Jokers) and shuffle deterministically.
 */
export function buildShuffledTwoDecks(seed: number): Card[] {
  const a = buildSingleDeck('d1');
  const b = buildSingleDeck('d2');
  const combined = [...a, ...b];
  const rng = mulberry32(seed);
  shuffleInPlace(combined, rng);
  return combined;
}

/**
 * Build ONE shuffled standard deck (54 cards: 52 + 2 Jokers).
 * Official match format uses one deck per half. `prefix` namespaces card IDs
 * so the two halves never collide if both deck records coexist in memory.
 */
export function buildShuffledSingleDeck(seed: number, prefix: string): Card[] {
  const cards = buildSingleDeck(prefix);
  const rng = mulberry32(seed);
  shuffleInPlace(cards, rng);
  return cards;
}
